import React from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import i18n from 'utils/I18n';
import { formatDate } from '../../utils/DateTimeUtils';
import './MyAccountMergeHistory.scss';

const MyAccountMergeHistory = ({
  transferredHistory,
}) => {
  if (!transferredHistory || !transferredHistory?.length) {
    return null;
  };

  return (
    <Container className="common-shadow-section-container account-merge-history-container">
      <div className="common-section-title title-medium-2">
        {i18n.t('accountMergeHistory')}
      </div>
      {
        transferredHistory?.map(item => (
          <div className='single-account-merge-history'>
            <div className='body-1'>
              <span>{i18n.t("accountMergeDate")}{i18n.t("accountMergeColon")}</span>
              <span className='account-merge-history-margin-left'>{formatDate(item?.creationDate)}</span>
            </div>
            <div className='body-1'>
              <span>{i18n.t("accountMergeMembershipId")}{i18n.t("accountMergeColon")}</span>
              <span className='account-merge-history-margin-left'>{item?.membershipId}</span>
            </div>
            {
              item?.mobile && (
                <div className='body-1'>
                  <span>{i18n.t("account_mobile")}{i18n.t("accountMergeColon")}</span>
                  <span className='account-merge-history-margin-left'>{item?.mobile}</span>
                </div>
              )
            }
            {
              item?.email && (
                <div className='body-1'>
                  <span>{i18n.t("settings_email")}{i18n.t("accountMergeColon")}</span>
                  <span className='account-merge-history-margin-left'>{item?.email}</span>
                </div>
              )
            }
          </div>
        ))
      }
    </Container>
  );
}

const mapStateToProps = (state) => ({
  transferredHistory: state.users.userInfo?.transferredHistory,
});

export default connect(mapStateToProps)(MyAccountMergeHistory);
